<template>
  <div class="feed-card feed__message-block">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step flex-shrink-0"></span>
      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>
        <div id="animation" class="animation" ref="lottieContainer" style="width: 100%; height: 100%"></div>
        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>
</template>

<script>
import TimeInfos from '@components/utils/TimeInfos.vue';
import lottie from 'lottie-web';

export default {
  props: {
    userActivity: Object
  },
  components: {
    TimeInfos
  },
  mounted() {
    const animation = lottie.loadAnimation({
      container: this.$refs.lottieContainer,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      speed: 1,
      path: '/assets/lotties/fireworks.json'
    });
  }
};
</script>